import * as React from 'react'

function SvgFileDownload(props, svgRef) {
  return (
    <svg viewBox="0 0 17 23" fill="none" xmlns="http://www.w3.org/2000/svg" ref={svgRef} {...props}>
      <path
        d="M17 5.75h-5.667V0L17 5.75zm-5.667 1.438H17v13.656c0 1.19-.951 2.156-2.125 2.156H2.125C.951 23 0 22.034 0 20.844V2.156C0 .966.951 0 2.125 0h7.792v5.75c0 .795.633 1.438 1.416 1.438zm-.044 6.064l-1.726 1.756v-4.586A1.07 1.07 0 008.5 9.344c-.587 0-1.063.485-1.063 1.078v4.586l-1.766-1.756c-.168-.211-.438-.315-.713-.315-.274 0-.543.104-.75.315a1.089 1.089 0 000 1.525l3.54 3.593a1.051 1.051 0 001.503 0l3.542-3.593a1.089 1.089 0 000-1.525 1.056 1.056 0 00-1.504 0z"
        fill="#204667"
      />
    </svg>
  )
}

const ForwardRef = React.forwardRef(SvgFileDownload)
export default ForwardRef
